/** @file IK timelines of one animation: mix and softness (curved), bend/stretch/compress flags. */
import type { AnimationDoc, TimelineJson } from '@pose2d/format/types';
import { byCompiledIndex } from './byCompiledIndex';
import { curvedTimeline } from './curvedTimeline';
import { discreteTimeline } from './discreteTimeline';
import { hasKeys } from './hasKeys';
import { requireCompiledIndex } from './requireCompiledIndex';

/** Per keyed constraint (compiled IK order): ikMix, ikSoftness, ikBend, ikStretch, ikCompress. */
export function ikTimelines(anim: AnimationDoc, fps: number, ikIndex: ReadonlyMap<string, number>, at: string): TimelineJson[] {
  const out: TimelineJson[] = [];
  for (const [id, tl] of byCompiledIndex(anim.ik, ikIndex)) {
    const ik = requireCompiledIndex(ikIndex, id, 'ik', `${at}.ik.${id}`);
    if (hasKeys(tl.mix)) out.push({ k: 'ikMix', ik, ...curvedTimeline(tl.mix, fps, (v) => v) });
    if (hasKeys(tl.softness)) out.push({ k: 'ikSoftness', ik, ...curvedTimeline(tl.softness, fps, (v) => v) });
    if (hasKeys(tl.bendPositive)) out.push({ k: 'ikBend', ik, ...discreteTimeline(tl.bendPositive, fps, (v) => v) });
    if (hasKeys(tl.stretch)) out.push({ k: 'ikStretch', ik, ...discreteTimeline(tl.stretch, fps, (v) => v) });
    if (hasKeys(tl.compress)) out.push({ k: 'ikCompress', ik, ...discreteTimeline(tl.compress, fps, (v) => v) });
  }
  return out;
}
